// How typing narrows a list of options, for the combo box and the multi-select.
//
// An option is `{ value, label }`, with `text` when the label carries something nobody types - a
// flag before a country's name. What is typed is matched against the text and the value, with
// case and accents folded out, so "cote" finds Côte d'Ivoire and "tg" finds Togo.
//
// Options that start with what was typed come before those that only contain it: someone typing
// "ni" wants Niger and Nigeria above Albania. Within each band the list keeps its own order.

const fold = (text) => String(text ?? '')
  .normalize('NFD')
  .replace(/\p{M}/gu, '')
  .toLowerCase()
  .trim();

const keysOf = (option) => [fold(option.text ?? option.label), fold(option.value)];

export function narrow(options, typed) {
  const wanted = fold(typed);
  if (!wanted) return options;

  const starting = [];
  const containing = [];
  for (const option of options) {
    const keys = keysOf(option);
    if (keys.some((key) => key.startsWith(wanted))) starting.push(option);
    else if (keys.some((key) => key.includes(wanted))) containing.push(option);
  }
  return [...starting, ...containing];
}

// The option a value names, or the value itself standing in for one: a stored value that has
// left the list - a deactivated product, a country typed before there was a list - is still
// shown, as it is stored.
export const optionFor = (options, value) =>
  options.find((option) => option.value === value) ?? { value, label: value };
